import { motion } from "framer-motion";

const ROTATIONS = [0, 46, 133, 180, 225, 315];

export default function NetworkViz({ center, nodes, small = false, testidPrefix = "network" }) {
  return (
    <div
      className={`relative w-full overflow-hidden border border-[#c9a45c]/25 ${small ? "min-h-[380px]" : "min-h-[460px]"}`}
      style={{
        background:
          "radial-gradient(circle at 50% 48%, rgba(201,164,92,0.1), transparent 40%), #0b0b0b",
      }}
      data-testid={`${testidPrefix}-viz`}
    >
      <div
        className="absolute inset-0"
        style={{
          backgroundImage:
            "linear-gradient(rgba(201,164,92,0.07) 1px, transparent 1px), linear-gradient(90deg, rgba(201,164,92,0.07) 1px, transparent 1px)",
          backgroundSize: "48px 48px",
          maskImage: "linear-gradient(to bottom, transparent, black 22%, black 78%, transparent)",
          WebkitMaskImage: "linear-gradient(to bottom, transparent, black 22%, black 78%, transparent)",
        }}
      />

      {ROTATIONS.map((deg, i) => (
        <motion.span
          key={i}
          className="network-line"
          style={{ rotate: deg }}
          initial={{ scaleX: 0, left: "50%", top: "50%" }}
          whileInView={{ scaleX: 1 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 1, delay: 0.2 + i * 0.12, ease: [0.16, 1, 0.3, 1] }}
        />
      ))}

      <motion.div
        className="absolute inset-0"
        initial={{ scale: 0.6, opacity: 0 }}
        whileInView={{ scale: 1, opacity: 1 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.8, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
      >
        <span className="hub-ring hub-ring-1" />
        <span className="hub-ring hub-ring-2" />
        <div
          className="hub-core"
          style={small ? { width: 118, height: 118, fontSize: 11 } : undefined}
          data-testid={`${testidPrefix}-core`}
        >
          {center}
        </div>
      </motion.div>

      {nodes.map((label, i) => (
        <motion.span
          key={label}
          className={`node n${i + 1} ${small ? "node-sm" : ""}`}
          initial={{ opacity: 0, scale: 0.85 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.55, delay: 0.55 + i * 0.1, ease: [0.16, 1, 0.3, 1] }}
          data-testid={`${testidPrefix}-node-${i + 1}`}
        >
          {label}
        </motion.span>
      ))}
    </div>
  );
}
